import * as notification from '../../components/notifications';

let selectedJobId = null;

const initPage = () => {
  const jobsList = $("#jobs-list-block");
  if (!jobsList.length) {
    return ;
  }

  $(".btn-delete-job", jobsList).click(function(){
    const jobId = $(this).data('jobId');
    askToDeleteJob(jobId);

    return false;
  });

  $("#modal-delete-job .btn-modal-confirm").click(function(){
    deleteSelectedJob();
  });
};

const askToDeleteJob = (id) => {
  selectedJobId = id;
  $('#modal-delete-job').modal('show');
};

const deleteSelectedJob = async () => {
  $("#modal-delete-job .btn-modal-confirm").loading(true);

  try {
    let response;
    response = await axios.delete("/api/jobs/" + selectedJobId);

    notification.success(response.data.message);

    $("#job-row-" + selectedJobId).remove();
    selectedJobId = null;

    $("#modal-delete-job .btn-modal-confirm").loading(false);
    $('#modal-delete-job').modal('hide');
  } catch (e) {
    $("#modal-delete-job .btn-modal-confirm").loading(false);
    $('#modal-delete-job').modal('hide');

    notification.danger(e.response.data.message);
  }
};

$(initPage);
